import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from '../global';



@Injectable()
export class UsuarioService {

    constructor(
        private http: HttpClient
    ) {}
    getUsuario(user: string): Observable<any> {
        return this.http.get(GLOBAL.url + '/usuario/usuario.php/usuario/' + user);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/usuario/usuario.service.ts